import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import client from '../../api/client';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Spinner from '../../components/ui/Spinner';
import { fechaLegible } from '../../utils/fechas';
import { Vacio } from './MisReservas';

const Panel = styled(Card)`
  max-width: 480px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.md};

  h2 {
    font-size: 1.4rem;
    color: ${({ theme }) => theme.colors.sageDeep};
  }
`;

const Numero = styled.p`
  font-family: ${({ theme }) => theme.fonts.heading};
  font-size: 3.2rem;
  line-height: 1;
  color: ${({ theme }) => theme.colors.sageDeep};

  span {
    font-family: ${({ theme }) => theme.fonts.body};
    font-size: 1rem;
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

const Fila = styled.div`
  display: flex;
  justify-content: space-between;
  font-size: 0.95rem;
  padding: 0.4rem 0;
  border-bottom: 1px solid ${({ theme }) => theme.colors.border};

  span:first-child {
    color: ${({ theme }) => theme.colors.textMuted};
  }
`;

function MiPaquete() {
  const [paquete, setPaquete] = useState();

  useEffect(() => {
    client.get('/paquetes/mio').then(({ data }) => setPaquete(data)).catch(() => setPaquete(null));
  }, []);

  if (paquete === undefined) return <Spinner />;

  if (!paquete) {
    return (
      <Vacio>
        No tienes un paquete activo. Revisa los <Link to="/paquetes">paquetes disponibles</Link> y
        actívalo en recepción.
      </Vacio>
    );
  }

  const ilimitado = paquete.tipo === 'ilimitado';

  return (
    <Panel>
      <div>
        <Badge $tono={ilimitado ? 'sage' : 'arena'}>{ilimitado ? 'Membresía ilimitada' : 'Paquete por clases'}</Badge>
      </div>
      <h2>{paquete.paquete_nombre}</h2>
      {ilimitado ? (
        <Numero>
          ∞ <span>clases hasta el {fechaLegible(paquete.fecha_vencimiento)}</span>
        </Numero>
      ) : (
        <Numero>
          {paquete.clases_restantes} <span>clases restantes</span>
        </Numero>
      )}
      <div>
        <Fila>
          <span>Inicio</span>
          <span>{fechaLegible(paquete.fecha_inicio)}</span>
        </Fila>
        <Fila>
          <span>Vence</span>
          <span>{fechaLegible(paquete.fecha_vencimiento)}</span>
        </Fila>
      </div>
    </Panel>
  );
}

export default MiPaquete;
